<ngx-spinner id="loading" type="ball-spin-clockwise" size="default">
    <p style="color: #ffffff;"> Loading... </p>
</ngx-spinner>
<router-outlet></router-outlet>
